import React from 'react';
import ResourceWorkspace from '../../components/admin/ResourceWorkspace';
import CustomerFundingPanel from '../../components/admin/CustomerFundingPanel';
import OperationsPanel from '../../components/admin/OperationsPanel';

const tabs = [
  {
    "title": "Accounts",
    "resource": "admin_rest/exchangeuser",
    "columns": [
      "id",
      "email",
      "date_joined",
      "is_active",
      "email_verified",
      "kyc",
      "two_fa",
      "orders_count",
      "withdrawals_count"
    ]
  },
  {
    "title": "Profiles",
    "resource": "core/profile"
  },
  {
    "title": "Restrictions",
    "resource": "core/userrestrictions"
  },
  {
    "title": "Balances",
    "resource": "admin_rest/balance"
  },
  {
    "title": "KYC",
    "resource": "core/userkyc"
  },
  {
    "title": "Source of funds",
    "resource": "core/sourceoffunds"
  },
  {
    "title": "Login history",
    "resource": "core/loginhistory"
  },
  {
    "title": "Access history",
    "resource": "core/accesslog"
  },
  {
    "title": "Email verification",
    "resource": "account/emailaddress"
  }
];

export default function UsersPage() {
  return <ResourceWorkspace title="Customer administration"  tabs={tabs}><div className="space-y-6"><CustomerFundingPanel /><OperationsPanel group="users" /></div></ResourceWorkspace>;
}
